/**
 * @param {Record<string, unknown> | null | undefined} node
 * @returns {Array<Record<string, unknown>>}
 */
export function collectArchivosFromNode(node) {
  if (!node || typeof node !== "object") {
    return [];
  }
  const out = Array.isArray(node.archivos) ? [...node.archivos] : [];
  for (const child of Array.isArray(node.hijos) ? node.hijos : []) {
    out.push(...collectArchivosFromNode(child));
  }
  return out;
}

/**
 * @param {Record<string, unknown> | null | undefined} node
 * @returns {Array<{ titulo?: string, bloque?: string }>}
 */
export function collectTestRefsFromNode(node) {
  if (!node || typeof node !== "object") {
    return [];
  }
  const out = Array.isArray(node.testRefs) ? [...node.testRefs] : [];
  for (const child of Array.isArray(node.hijos) ? node.hijos : []) {
    out.push(...collectTestRefsFromNode(child));
  }
  return out;
}
